import { render, staticRenderFns } from "./vehicleViolationAdd.vue?vue&type=template&id=c0b0cd46&scoped=true"
import script from "./vehicleViolationAdd.vue?vue&type=script&lang=js"
export * from "./vehicleViolationAdd.vue?vue&type=script&lang=js"
import style0 from "./vehicleViolationAdd.vue?vue&type=style&index=0&id=c0b0cd46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b0cd46",
  null
  
)

export default component.exports